import { jsxs as a, Fragment as g, jsx as e } from "react/jsx-runtime";
import { Option as l } from "../styled.js";
const h = ({ inputValue: n = "" }) => ({ innerProps: r, ...i }) => {
  const { label: t, isFocused: c } = i, s = t.toLowerCase().indexOf(n.toLowerCase()), o = s + n.length, d = /* @__PURE__ */ a(g, { children: [
    t.substring(0, s),
    /* @__PURE__ */ e("strong", { children: t.substring(s, o) }),
    t.substring(o)
  ] });
  return /* @__PURE__ */ e(l, { ...r, $isFocused: c, children: s >= 0 ? d : t });
};
export {
  h as default
};
